import { isEmpty } from "lodash";
import { match, matchPath } from "react-router-dom";

import { RouteComponentType } from "./RouteWithSubRoutes";

export const matchRoutes = (
  routes: RouteComponentType[],
  pathname: string
): match<any> | null => {
  let matchedRoute: match<any> | null = null;
  routes.some((route) => {
    matchedRoute = matchPath(pathname, route);
    if (!matchedRoute && !isEmpty(route.routes)) {
      matchedRoute = matchRoutes(route.routes!, pathname);
    }
    return !!matchedRoute;
  });
  return matchedRoute;
};
